export var ClientSocketMessageType = /*#__PURE__*/ function(ClientSocketMessageType) {
    ClientSocketMessageType[ClientSocketMessageType["RouteToServerType"] = 2] = "RouteToServerType";
    ClientSocketMessageType[ClientSocketMessageType["RouteToServerDirect"] = 3] = "RouteToServerDirect";
    ClientSocketMessageType[ClientSocketMessageType["SocketRouter"] = 4] = "SocketRouter";
    return ClientSocketMessageType;
}({});
const textDecoder = new TextDecoder();
const textEncoder = new TextEncoder();
const TYPE_LENGTH = 1;
const TYPE_INDEX = 0;
const SUBTYPE_LENGTH = 1;
const SUBTYPE_INDEX = TYPE_INDEX + TYPE_LENGTH;
const RECIPIENT_LENGTH_LENGTH = 1;
const RECIPIENT_LENGTH_INDEX = SUBTYPE_INDEX + SUBTYPE_LENGTH;
const RECIPIENT_INDEX = RECIPIENT_LENGTH_INDEX + RECIPIENT_LENGTH_LENGTH;
// binary format: "type byte|recipient length byte|encoded recipient|data"
export function createBinaryClientSocketMessage(type, subType, recipient, data) {
    const encodedRecipient = textEncoder.encode(recipient);
    const binary = new Uint8Array(TYPE_LENGTH + SUBTYPE_LENGTH + RECIPIENT_LENGTH_LENGTH + encodedRecipient.byteLength + data.byteLength);
    const binaryView = new DataView(binary.buffer);
    binaryView.setUint8(TYPE_INDEX, type);
    binaryView.setUint8(SUBTYPE_INDEX, subType);
    binaryView.setUint8(RECIPIENT_LENGTH_INDEX, encodedRecipient.byteLength);
    binary.set(encodedRecipient, RECIPIENT_INDEX);
    binary.set(data, RECIPIENT_INDEX + encodedRecipient.byteLength);
    return binary.buffer;
}
export function parseBinaryClientSocketMessage(binaryMessage) {
    const type = binaryMessage[TYPE_INDEX];
    const subType = binaryMessage[SUBTYPE_INDEX];
    const recipientLength = binaryMessage[RECIPIENT_LENGTH_INDEX];
    const recipient = textDecoder.decode(binaryMessage.slice(RECIPIENT_INDEX, RECIPIENT_INDEX + recipientLength));
    const data = binaryMessage.slice(RECIPIENT_INDEX + recipientLength);
    return {
        type: type,
        subType: subType,
        recipient: recipient,
        data: data
    };
}
